export class User {

   static parse(source: any = {}): User {
      if (typeof source.username === "string" && source.username !== "") {
         return new User(source.username, //
            PermissionSet.parse(source.instances), //
            PermissionSet.parse(source.licences));
      }
      throw new Error("Could not parse a valid User object");
   }

   constructor(username: string, instancePerms: PermissionSet, licencePerms: PermissionSet) {
      this.username = username;
      this.permissions = {
         instance: instancePerms,
         licence: licencePerms
      };
   }

   readonly username: string;
   readonly permissions: { instance: PermissionSet, licence: PermissionSet };
}


export class PermissionSet {

   static parse(source: any = {}): PermissionSet {
      return new PermissionSet(!!source.canView, !!source.canEdit);
   }

   constructor(
      readonly canView: boolean,
      readonly canEdit: boolean
   ) { }
}
